import { Helmet } from "react-helmet";

const services = [
  {
    id: 1,
    title: "Yüz Dolgu Uygulamaları",
    desc: "Yaşa bağlı kaybolan hacmin geri kazandırılması, dudak şekillendirme, elmacık kemiği kontürü için hyaluronik asit bazlı dolgular.",
    img: "https://images.pexels.com/photos/7581590/pexels-photo-7581590.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    id: 2,
    title: "Botoks (Dinamik Çizgi Tedavisi)",
    desc: "Alın, kaş arası ve göz çevresindeki mimik çizgilerinin giderilmesi. Yüz simetrisinin düzeltilmesi.",
    img: "https://images.pexels.com/photos/7581583/pexels-photo-7581583.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    id: 3,
    title: "Cilt Gençleştirme & Mezoterapi",
    desc: "PRP, vitamin kokteylleri ve hyaluronik asit ile cildin yenilenmesi, nem dengesinin sağlanması, lekelerin azaltılması.",
    img: "https://images.pexels.com/photos/7581577/pexels-photo-7581577.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
];

function Services() {
  return (
    <section id="services">
      <Helmet>
        <title>
          Medikal Estetik Hizmetlerimiz | Botoks, Dolgu, PRP | Dr. Tayfun
          Giyik
        </title>
        <meta
          name="description"
          content="Dr. Tayfun Giyik'in sunduğu medikal estetik hizmetleri: Yüz dolgusu, botoks, mezoterapi, PRP ve sıvı yüz germe."
        />
        <link
          rel="canonical"
          href="https://www.drtayfungiyik.com.tr/hizmetler"
        />
        <meta property="og:title" content="Medikal Estetik Hizmetlerimiz" />
        <meta
          property="og:description"
          content="Profesyonel medikal estetik çözümleri."
        />
      </Helmet>
      <h2 className="section-title">Hizmetlerimiz</h2>
      <div className="services-grid">
        {services.map((service) => (
          <div className="service-card" key={service.id}>
            <img src={service.img} alt={service.title} />
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;
